import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios"
import { Modal } from '../Components/Modal';
import { DialogModal } from '../Components/DialogModal';

import { useUser } from "../Contexts/UserContext";


import { CLIENT, OAUTH_URI, API_BASE_URI, API_URI, ACCOUNTS_URI, APP_URI } from '../config/constants';

export function Welcome() {
    const { user, updateUser, closeUserSession } = useUser();

    const [username, setUsername] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [decision, setDecision] = useState(false);
    const navigate = useNavigate();
    const [infoModal, setInfoModal] = useState(false);
    const [dialogModal, setDialogModal] = useState(false);

    const [navigateUnauthorized, setNavigateUnauthorized] = useState(false);

    useEffect(() => {
        let jwt = sessionStorage.getItem("jwt");
        if(jwt != null) {
            getUserName(jwt);
        }
        else { 
            navigate("/login");
            //setNavigateUnauthorized(true);
            //displayModalMessage("User is Unauthorized")
        }
        },[]
      );  

      const onModalClose = () => {
        if(navigateUnauthorized) {
            navigate("/unauthorized");
        }
      }

      async function getUserName(jwt) {
        await axios.get(API_URI + "/user/user-info", 
                {  //Adding token to the request
                  headers: {
                    'Authorization': `Bearer ${jwt}`
                  }
                }
            ).then((response) => {
                if (response.status === 200) {
                    const userInfo = response.data;
                    updateUser(userInfo);
                    setUserInfo(userInfo);
                }
                handleResponse(response);
            }).catch((error) => {
                console.log("ERROR: while obtaining user info: "+error.message);
                handleResponse(error.response);
                displayModalMessage(error.message);
            });
      } 

      function setUserInfo(userInfo) {
        if(userInfo) { 
          setUsername(userInfo.first_name+" "+userInfo.last_name);
          //setImage(userInfo.base64Image);
        }
      }

      const handleLogout = () => {
        if(decision) {
          navigate("/logout");
        }
      }

      function displayModalMessage(message) {
        setModalMessage(message);
        setInfoModal(true);
      }

      function displayDialogModalMessage(message) {
        setModalMessage(message);
        setDialogModal(true);
      }

      function handleError(response) {
        console.log("ERROR: with status: "+response.status+
          " "+response.data.responseCode);
      }
    
      function handleResponse(response) {
        if(response == null || response.data == null) {
          return;
        }
      }

      function logout() {
        displayDialogModalMessage("Are you sure you want to log out?");
      }

    return (
        <>
            <h1>Welcome {username}</h1>
            
            Admin approval for your account is pending. 
            <br></br>
            You will receive an onboading email from admin@radikle.com. 
            <br></br>
            <br></br>
            <button id="logout-button" className="Login-button" onClick={logout}><span>Logout</span></button>
            
            <Modal message={modalMessage} show={infoModal} setInfoModal={setInfoModal} onModalClose={onModalClose}></Modal>
            <DialogModal message={modalMessage} show={dialogModal} setDialogModal={setDialogModal} setDecision={setDecision} onModalClose={handleLogout}></DialogModal>
        </>
    )
}
